module.exports = __webpack_public_path__ + "img/qrcodestudent.739fce88.png";